
import { ModalMultiSelectList } from './modals/modalMultiSelectList.js';

export class MultiSelect {

   constructor(settings) {

      let defaults = {
         listTitle: "Bitte wählen",
         addData: false,
         getItems: function() { return null; },
         listSettings: { multiAction: false, hideMultiActionFooter: true, showHeader: false, onSelected: (val) => this.elList.onSelect(val) },
         itemTextValue: function(item) { return null; },
         itemSortValue: function(item) { return 0; },
         itemId: function(item) { return null; },
         onChange: function(items) { return null; }
      };

      this.set = Object.extend(true, defaults, settings);

      this.elMain = HTMLElement.createFromHTML(
         '<div class="multi-select">'
       + '   <div class="selected"></div>'
       + '   <div class="btn-add"><i class="icon-plus"></i></div>'
       + '</div>'
      );

      this.elSelected = this.elMain.querySelector('.selected');
      this.elBtnAdd   = this.elMain.querySelector('.btn-add');
      
      /*
      this.elList = HTMLElement.createFromHTML(
         '<div class="multi-select-list">'
       + '   <div class="main">'
       + '      <div class="search"><input type="text"></input></div>'
       + '      <div class="items">'
       + '         <div class="fav-list"></div>'
       + '         <div class="list"></div>'
       + '      </div>'
       + '      <div class="buttons">'
       + '         <div class="btn-cancel button-circle"><i class="icon-cross"></i></div>'
       + '         <div class="btn-ok button-circle"><i class="icon-check"></i></div>'
       + '      </div>'
       + '   </div>'
       + '</div>'
      );
      */

      //document.querySelector('body').appendChild(this.elList);

      this.elBtnAdd.onclick = () => this.loadList();
      this.elSelected.onclick = () => this.loadList();

   }

   

   

   renderItem(item) {

      let elSelected = HTMLElement.createFromHTML(
         '<div class="selected-item">'
         + '   <div class="name">' + this.set.itemTextValue(this.set.addItem ? item.data : item) + '</div>'
         + '   <div class="btn-delete"><div class="font-icon icon-cross"></div></div>'
         + '</div>'
      );

      elSelected.setData('item', item);

      return elSelected;

   }

   addItems(items, triggerChange) {

      for (let item of items) {

         let elSelected = this.renderItem(item);

         elSelected.querySelector('.btn-delete').onclick = (event) => {
            event.stopPropagation();
            event.currentTarget.parentNode.remove();
            this.set.onChange(this.getSelectedItems());
         };
         this.elSelected.appendChild(elSelected);
      }

      if (triggerChange) this.set.onChange(this.getSelectedItems());

   }

   search(text) {
      this.loadList(text);
   }

   setSelection(items) {
      this.elSelected.empty();

      let allItems = this.set.getItems();
      let itemsMap = {};
      allItems.list.map(   item => itemsMap[this.set.itemId(item)] = item);
      allItems.favList.map(item => itemsMap[this.set.itemId(item)] = item);

      if (items.length > 0 && typeof items[0] !== 'object') {
         items = items.map(item => { return { id: item }; });
      }

      let selected = [];
      for (let item of items) {
         let id = item.id;
         if (id in itemsMap) {
            if (this.set.addData) selected.push({ data: itemsMap[id], info: item.info });
            else selected.push(itemsMap[id]);
         }
      }
      this.addItems(selected, true);

   }


   getSelectedItemIds() {
      let selected = this.getSelectedItems();
      return selected.map(item => this.set.itemId(this.set.addData ? item.data : item));
   }

   getSelectedItems() {
      let selected = [];

      this.elSelected.querySelectorAll('.selected-item').forEach(elSelected => {
         selected.push(elSelected.getData('item'));
      });

      return selected;
   }


   loadList(searchValue) {

      this.elList = new ModalMultiSelectList(this, this.set.getItems(), this.getSelectedItemIds());

   }

   /*
   updateStatus() {

      this.elHours.querySelectorAll('.selection.between').forEach(item => item.remove());

      let selections = this.elHours.querySelectorAll('.hour.selected');

      if (selections.length === 0) {
         this.selectedHour = { from: false, to: false };
      }
      else if (selections.length === 1) {
         let hour = parseInt(selections[0].dataset.hour);
         this.selectedHour = { from: hour+1, to: hour+1 };
      }
      else if (selections.length === 2) {
         let hourFrom = parseInt(selections[0].dataset.hour);
         let hourTo   = parseInt(selections[1].dataset.hour);
         this.selectedHour = { from: hourFrom+1, to: hourTo+1 };
         let elBetween = selections[0];

         while (elBetween !== selections[1]) {
            let hour = parseInt(elBetween.dataset.hour);
            let elSelection = this.elHours.createElement('div', 'selection between' + (elBetween === selections[0] ? ' first' : ''));
            elSelection.style.gridArea = `${Math.floor(hour/6) + 1} / ${(hour%6) + 1}`;
            elBetween = elBetween.nextSibling;
         }
      }

   }

   getSelection() {
      return this.selectedHour;
   }
   */

   getElement() {
      return this.elMain;
   }

   appendTo(parent) {
      this.elMain = parent.appendChild(this.elMain);
   }

}
